import { render, staticRenderFns } from "./start-trading-slider.vue?vue&type=template&id=9f304a76&scoped=true&"
import script from "./start-trading-slider.vue?vue&type=script&lang=js&"
export * from "./start-trading-slider.vue?vue&type=script&lang=js&"
import style0 from "./start-trading-slider.vue?vue&type=style&index=0&id=9f304a76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f304a76",
  null
  
)

export default component.exports